interface PaginationProps {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  totalItem: number;
  pageSize: number;
}

const Pagination = ({
  currentPage,
  setCurrentPage,
  totalItem,
  pageSize
}: PaginationProps) => {
  const visiblePages = 5;
  const pages = [];
  const totalPages = Math.ceil(totalItem / pageSize);

  if (totalPages <= visiblePages) {
    pages.push(...Array.from({ length: totalPages }, (_, index) => index + 1));
  } else {
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);

    if (startPage > 1) {
      pages.push(1, "...");
    }

    if (currentPage >= 3 && currentPage < totalPages - 1) {
      pages.push(currentPage);
    } else {
      pages.push(
        ...Array.from(
          { length: endPage - startPage + 1 },
          (_, index) => startPage + index
        )
      );
    }

    if (endPage < totalPages) {
      pages.push("...", totalPages);
    }
  }

  const handlePageClick = (page: number | string) => {
    if (page === "...") return;
    setCurrentPage(page as number);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  return (
    <div className="pagination d-flex justify-content-center">
      <button
        className="pagination-button pagination-text my-auto m-0 pl-0"
        onClick={() => handlePreviousPage()}
        disabled={currentPage === 1}
      >
        <i className="icon arrow-left" />
        <span>ก่อนหน้า</span>
      </button>
      <div className="pagination">
        {pages.map((page, index) => (
          <button
            key={index}
            className={`pagination-button ${currentPage === page ? "active" : ""}`}
            onClick={() => handlePageClick(page)}
          >
            <span>{page}</span>
          </button>
        ))}
      </div>
      <button
        className="pagination-button pagination-text my-auto mx-0 pr-0"
        onClick={() => handleNextPage()}
        disabled={currentPage === totalPages}
      >
        <span>ต่อไป</span>
        <i className="icon arrow-right" />
      </button>
    </div>
  );
};

export default Pagination;
